module.exports = __webpack_public_path__ + "img/solucion-networking.b53d8b9f.png";